module.exports = __webpack_public_path__ + "img/preloader-transport.9e419d55.svg";